// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @components
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');

// @actions
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');

class BrokerMiFIDBehaviorIgnoringPreviousResults extends React.Component {
    componentWillMount() {
        this.props.onIgnorePreviousTestResults();
    }

    render() {
        return (
            <BrokerMiFIDBehavior {...this.props}>
                {this.props.children}
            </BrokerMiFIDBehavior>
        );
    }
}

BrokerMiFIDBehaviorIgnoringPreviousResults.propTypes = {
    onIgnorePreviousTestResults: PropTypes.func.isRequired,
    children: PropTypes.any
};

module.exports.constructor = BrokerMiFIDBehaviorIgnoringPreviousResults;

module.exports.BrokerMiFIDBehaviorIgnoringPreviousResults = connect(
    null,
    {
        onIgnorePreviousTestResults: BrokerConvenienceMiFIDTestAction.hardReset
    }
)(BrokerMiFIDBehaviorIgnoringPreviousResults);
